import * as React from 'react';

// import { Link } from 'react-router-dom';
import { Col,  Row} from 'reactstrap';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';
import './onBoardingCommon.scss';

// toast
import 'react-toastify/dist/ReactToastify.css';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

import {createItemGen, currentBaseUrl, currentProfile, getGeneralSmartTableData, iconUrl, isFirstLogIn , isUserLoggedIn, setProfileData, isBasicPreassessmentDone} from '../../common/services';


// avatar
import Avatar from 'react-avatar';

import { CSSTransition} from 'react-transition-group';
// main styling
import './onBoardingCommon.css';

class SetAvatarPage extends React.Component {


    public state = {
      baseurl: currentBaseUrl(),
      iconfields: {
        filename: 'filename',
        id: 'id',
        name: 'Title',
      },
      icons: [],
      loaded: false,
      password: '',
      // toDashboard: false,
      toAssessmentGuide: false,
      toLogin: false,
      username: '',
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.handlesuccess = this.handlesuccess.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
        this.avatar_click = this.avatar_click.bind(this);
    }

    public goToLogin(){
        this.setState({ toLogin: true });
    }

    public handleGenSmartDataLoaded(key,objkey, res) {
      if(res.code ===200){
          console.log(key);
          this.setState({loaded: true});
          this.setState({[key]: res.response[objkey]});
      }
      if(res.code ===401){
          this.onLogout('arg');
          console.log('logout')
      }
    }

    public avatar_click(arg, e) {
        console.log(arg);
        this.setState({loaded: false});

        const item = {
            avatar: arg,
        }

        createItemGen( 'admin/userprofiles/set_avatar/', item, text => this.handleprofile(text));
    }
    public componentDidMount() {
      if(!isFirstLogIn() && isUserLoggedIn()){
        this.setState({ toDashboard: true });
      }
      else if(isFirstLogIn() && isUserLoggedIn()){
        this.setState({ toDashboard: false });
        getGeneralSmartTableData( 'admin/icons/avatar_items/', text => this.handleGenSmartDataLoaded('icons', 'icons',text));
      }
      else{
        this.setState({ toLogin: true });
      }
    }

    public onLogout(arg) {
      // console.log('dummy');
      this.setState({tologin: true});
    }

    public handlesuccess() {
        this.setState({baseurl: currentBaseUrl()});
        // history.push('/login');
        this.setState({toAssessmentGuide: true});
    }

    public handleprofile(res) {

      if(res.code ===200){
        toast("Profile update successful");
        this.setState({loaded: true});
        console.log(res.response);
        const cp = currentProfile();
        cp.Profiledata = res.response.data
        setProfileData(cp);
        setTimeout(this.handlesuccess, 1000);
      }

      else if(res.code ===404){
        this.setState({loaded: true});
        toast("Operation failed, try again");
        console.log(res);
      }

      else if(res.code ===400){
        this.setState({loaded: true});
        toast("Signup failed, username already exists");
        console.log(res);
      }

    }

    public render() {
      if (this.state.toAssessmentGuide === true) {
        return <Redirect to={this.state.baseurl + 'preassessmentguide'}/>
      }
      if (this.state.toLogin === true) {
        return <Redirect to='/login'/>
      }

      return (
        <div>
          <NavBar logoutParent={this.onLogout}/>
          <ToastContainer />
          <CSSTransition
                    in={true}
                    appear={true}
                    classNames="fade"
                    timeout={800}
                >
          <div>
            <Row className="center-avatar-container">

             <Col xs="12" sm="12" lg="12" className="avatar-header-copy">
                <h1 className="select-your-avatar">Select your <span>avatar</span></h1>
                <p className="secondary-text-set-avatar">You'll be able to change this from your profile page
                </p>
            </Col>

            <Loader loaded={this.state.loaded}>
              <Col xs="12" sm="12" lg="12">

                <ul style={{margin: "0 auto"}}>


                  {this.state.icons.map((d, i) => <li style={{margin: 5, height: 220, display: 'inline'}} key={d[this.state.iconfields.filename]}><Avatar style={{cursor: 'pointer'}} facebook-id="invalidfacebookusername" round="25px" size="110"  src={iconUrl(d[this.state.iconfields.filename])} onClick={this.avatar_click.bind(this, d[this.state.iconfields.filename])}/></li>)}



                </ul>

              </Col>
              </Loader>
            </Row>
          </div>
          </CSSTransition>
        </div>
      );
    }
}

export default SetAvatarPage;



// WEBPACK FOOTER //
// ./src/pages/Onboarding/setAvatarPage.Component.tsx